import React from 'react'
import Linkedin from '../assets/Linkedin1.png'
import Github from '../assets/github1.png'
import Gmail from '../assets/gmail1.png'
import UofT from '../assets/uoft.png'


function Social(props){
    return(
        <div className = 'grid grid-cols-2 justify-items-center pt-8 gap-4 md:flex md:flex-row md:gap-10 md:justify-center'>
            <a href = "mailto: aarinjasikumar@gmail.com" className = "shadow-lg shadow-[#000000] hover:scale-110 duration-500 bg-[#c6c6c6] md:w-[250px] md:h-[120px] flex justify-center items-center">
                <img src={Gmail} alt = 'gmail-logo' className='px-4'></img>
            </a> 
            <a href = "https://github.com/Aarin06" className = "shadow-lg shadow-[#000000] hover:scale-110 duration-500 bg-[#6e5494] md:w-[250px] md:h-[120px] flex justify-center items-center">
                <img src={Github} alt = 'gmail-logo' className='px-4'></img>
            </a> 
            <a href = "https://linkedin.com/in/aarin-jasikumar" className = "shadow-lg shadow-[#000000] hover:scale-110 duration-500 bg-white md:w-[250px] md:h-[120px] flex justify-center items-center">
                <img src={Linkedin} alt = 'gmail-logo' className='px-4'></img>
            </a> 
            <a href = "mailto: aarin.jasikumar@mail.utoronto.ca" className = "shadow-lg shadow-[#000000] hover:scale-110 duration-500 bg-[#c6c6c6] md:w-[250px] md:h-[120px] flex justify-center items-center">
                <img src={UofT} alt = 'gmail-logo' className='px-2'></img>
            </a>
        </div>
        
    )

}

export default Social;